import { React, useEffect, useMemo } from "react";
import CustomInput from "../../components/CustomInput";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import Dropzone from "react-dropzone";
import { delImg, uploadImg } from "../../features/upload/uploadSlice";
import { toast } from "react-toastify";
import * as yup from "yup";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useFormik } from "formik";
import {
  createPage,
  getAPage,
  resetState,
  updateAPage,
} from "../../features/cms/pages/cmsPagesSlice";

let schema = yup.object().shape({
  title: yup.string().required("Title is Required"),
  content: yup.string().required("Content is Required"),
});

const AddPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const getPageId = location.pathname.split("/")[4];
  const imgState = useSelector((state) => state?.upload?.images);
  const pageState = useSelector((state) => state.cmsPages);

  const {
    isSuccess,
    isError,
    isLoading,
    createdPage,
    pageTitle,
    pageContent,
    pageMetaTitle,
    pageMetaDescription,
    pageMetaKeywords,
    pageIsPublished,
    pageOrder,
    pageImages,
    updatedPage,
  } = pageState;

  useEffect(() => {
    dispatch(resetState());
  }, []);

  useEffect(() => {
    if (getPageId !== undefined) {
      dispatch(getAPage(getPageId));
    }
  }, [getPageId]);

  useEffect(() => {
    if (isSuccess && createdPage) {
      toast.success("Page Added Successfully!");
      navigate("/admin/cms/pages");
    }
    if (isSuccess && updatedPage) {
      toast.success("Page Updated Successfully!");
      navigate("/admin/cms/pages");
    }
    if (isError) {
      toast.error("Something Went Wrong!");
    }
  }, [isSuccess, isError, isLoading, navigate, createdPage, updatedPage]);

  const img = [...(imgState || [])];
  if (pageImages && Array.isArray(pageImages)) {
    pageImages.forEach((i) => {
      if (!img.find((existing) => existing.public_id === i.public_id)) {
        img.push({
          public_id: i.public_id,
          url: i.url,
        });
      }
    });
  }

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      title: pageTitle || "",
      content: pageContent || "",
      metaTitle: pageMetaTitle || "",
      metaDescription: pageMetaDescription || "",
      metaKeywords: pageMetaKeywords || "",
      isPublished: pageIsPublished !== undefined ? pageIsPublished : true,
      order: pageOrder || 0,
      images: img || [],
    },
    validationSchema: schema,
    onSubmit: (values) => {
      if (getPageId !== undefined) {
        dispatch(updateAPage({ id: getPageId, pageData: values }));
        dispatch(resetState());
      } else {
        dispatch(createPage(values));
        formik.resetForm();
        setTimeout(() => {
          dispatch(resetState());
        }, 300);
      }
    },
  });
const mergedImages =useMemo(() => {
  const existingImages = pageImages || [];
  const uploadedImages = imgState || [];
  const combined = [...uploadedImages];

  existingImages.forEach((img) => {
    if (!combined.find((i) => i.public_id === img.public_id)) {
      combined.push(img);
    }
  });

  return combined;
}, [imgState, pageImages]);
useEffect(() => {
  formik.setFieldValue("images", mergedImages);
}, [mergedImages]);


  return (
    <div>
      <h3 className="mb-4 title">
        {getPageId !== undefined ? "Edit" : "Add"} Page
      </h3>

      <div className="">
        <form action="" onSubmit={formik.handleSubmit}>
          <div className="mt-4">
            <CustomInput
              type="text"
              label="Enter Page Title"
              name="title"
              onChng={formik.handleChange("title")}
              onBlr={formik.handleBlur("title")}
              val={formik.values.title}
            />
          </div>
          <div className="error">
            {formik.touched.title && formik.errors.title}
          </div>

          <div className="mt-3">
            <label className="mb-2">Content</label>
            <ReactQuill
              theme="snow"
              value={formik.values.content}
              onChange={(value) => formik.setFieldValue("content", value)}
            />
          </div>
          <div className="error">
            {formik.touched.content && formik.errors.content}
          </div>

          <div className="mt-3">
            <CustomInput
              type="text"
              label="Meta Title (SEO)"
              name="metaTitle"
              onChng={formik.handleChange("metaTitle")}
              onBlr={formik.handleBlur("metaTitle")}
              val={formik.values.metaTitle}
            />
          </div>

          <div className="mt-3">
            <label className="mb-2">Meta Description (SEO)</label>
            <textarea
              className="form-control"
              name="metaDescription"
              rows="3"
              onChange={formik.handleChange("metaDescription")}
              onBlur={formik.handleBlur("metaDescription")}
              value={formik.values.metaDescription}
            />
          </div>

          <div className="mt-3">
            <CustomInput
              type="text"
              label="Meta Keywords (SEO)"
              name="metaKeywords"
              onChng={formik.handleChange("metaKeywords")}
              onBlr={formik.handleBlur("metaKeywords")}
              val={formik.values.metaKeywords}
            />
          </div>

          <div className="mt-3">
            <CustomInput
              type="number"
              label="Order (Display Order)"
              name="order"
              onChng={formik.handleChange("order")}
              onBlr={formik.handleBlur("order")}
              val={formik.values.order}
            />
          </div>

          <div className="mt-3">
            <div className="form-check">
              <input
                className="form-check-input"
                type="checkbox"
                id="isPublished"
                checked={formik.values.isPublished}
                onChange={(e) =>
                  formik.setFieldValue("isPublished", e.target.checked)
                }
              />
              <label className="form-check-label" htmlFor="isPublished">
                Published
              </label>
            </div>
          </div>

          <div className="bg-white border-1 p-5 text-center mt-3">
            <Dropzone
              onDrop={(acceptedFiles) => dispatch(uploadImg(acceptedFiles))}
            >
              {({ getRootProps, getInputProps }) => (
                <section>
                  <div {...getRootProps()}>
                    <input {...getInputProps()} />
                    <p>
                      Drag 'n' drop some files here, or click to select files
                    </p>
                  </div>
                </section>
              )}
            </Dropzone>
          </div>
          <div className="showimages d-flex flex-wrap mt-3 gap-3">
            {img?.map((i, j) => {
              return (
                <div className=" position-relative" key={j}>
                  <button
                    type="button"
                    onClick={() => dispatch(delImg(i.public_id))}
                    className="btn-close position-absolute"
                    style={{ top: "10px", right: "10px" }}
                  ></button>
                  <img src={i.url} alt="" width={200} height={200} />
                </div>
              );
            })}
          </div>

          <button
            className="btn btn-success border-0 rounded-3 my-5"
            type="submit"
          >
            {getPageId !== undefined ? "Update" : "Add"} Page
          </button>
        </form>
      </div>
    </div>
  );
};

export default AddPage;

